module.exports = __webpack_public_path__ + "img/wallet.ada8abe1.svg";